<template>
  <sf-openEwallet></sf-openEwallet>
</template>

<script>
import SfOpenEwallet from './children/open-ewallet.vue';

export default {
  name: 'eWalletOpen',
  data () {
    return {
      pageTitle: '开通电子钱包',
    }
  },
  components: {
    SfOpenEwallet,
  }
}
</script>